import { BaseElement } from '@nrk/dh-server-libs/base-element'
import { getElementTag } from '@nrk/dh-server-libs/get-element-tag'
import './components/App.module.css'

const tag = getElementTag(__APP_NAME__, __APP_VERSION__)

class AppElement extends BaseElement {
  name = tag

  render() {
    let hasIntersected = false

    const handleIntersect = (entries: IntersectionObserverEntry[]) => {
      if (!hasIntersected) {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            this.sendGaEvent({
              eventAction: 'intersecting',
              eventLabel: 'Bruker har sett heiboksen',
            })
            hasIntersected = true
          }
        })
      }
    }

    this.sendGaEvent({ eventAction: `MOUNT:${tag}` })

    const emailLink = this.querySelector('a.nrk-button')
    emailLink.addEventListener('click', () => {
      this.sendGaEvent({ eventAction: 'click', eventLabel: 'send-email' })
    })

    const intersectionOptions = {
      root: null,
      rootMargin: '0px',
      threshold: 1.0,
    }

    // eslint-disable-next-line compat/compat
    const observer = new IntersectionObserver(handleIntersect, intersectionOptions)
    observer.observe(this)
  }
}

if (!customElements.get(tag)) {
  customElements.define(tag, AppElement)
}
